import { textureAssetCompressed } from '@/src/game/assetStore'

export const CHAMELEON_TEXTURE_PRESETS = [
    { id: '01', label: 'Texture 1', value: textureAssetCompressed.Chameleon_Color_01, border: '#80A8C7', gradient: '/images/editor/Color Choice Multi.png' },
    { id: '04', label: 'Texture 4', value: textureAssetCompressed.Chameleon_Color_02, border: '#7F0016', gradient: '/images/editor/Color Choice Orange.png' },
    { id: '02', label: 'Texture 2', value: textureAssetCompressed.Chameleon_Color_04, border: '#1F4B0E', gradient: '/images/editor/Color Choice Green.png' },
    { id: '03', label: 'Texture 3', value: textureAssetCompressed.Chameleon_Color_03, border: '#0A2897', gradient: '/images/editor/Color Choice Blue.png' },
] as const

const chameleonTextureIds = CHAMELEON_TEXTURE_PRESETS.map(
    (preset) => preset.id,
) as Array<(typeof CHAMELEON_TEXTURE_PRESETS)[number]['id']>

function pickDifferent<T>(options: readonly T[], current: T, equals: (a: T, b: T) => boolean): T {
    const others = options.filter((option) => !equals(option, current))
    const pool = others.length > 0 ? others : options
    return pool[Math.floor(Math.random() * pool.length)]!
}

export type RandomChameleonRoll = {
    texture: (typeof CHAMELEON_TEXTURE_PRESETS)[number]['id']
}

export function rollRandomChameleonCustomization(current: {
    texture: string
}): RandomChameleonRoll {

    return {
        texture: pickDifferent(
            chameleonTextureIds,
            current.texture as (typeof CHAMELEON_TEXTURE_PRESETS)[number]['id'],
            (a, b) => a === b,
        ),
    }
}
